module.exports = __webpack_public_path__ + "static/media/mint-btn.cee192ae.png";